/* global ma */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';

window.onload = () => {
//   getLocalStorageData();
};


export const paymentListPageApi = createApi({
  reducerPath: 'paymentListPageApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://apiv2.shwenarsin.com/api/' }),
  endpoints: (builder) => ({
    fetchPaymentListData: builder.query({
      query: () => ({
        url : 'payment/package/list',
        method: 'POST',
        body : {
            "payment_id": "sns_kbz_mini",
            "phone": "",
            "platform": "miniapp",
            "udid": "190740e5f0032702",
            "user_id": getLocalStorageData(),
            "version_code": 99,
            "version_name": "1.2.9"
        }
      }), 
    })
  }),
});

export const { useFetchPaymentListDataQuery, endpoints } = paymentListPageApi;